import { Modal } from 'bootstrap'
import { validateAndGet } from '../../helpers/validation.js'
import { PointLoad, DistLoad } from '../../models/load.js'
import {showFeetInches, showBigLinearForce, showKips, showKipFt, wsParseLength, wsParseForce, wsParseMoment, wsParseForcePerLength} from '../../units/units.js'

let distLoads = []
let pointLoads = []
let beamLength = 144

class LoadEditorDialogComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('shear-moment-project-loaded', async (event) => this.onUpdate(event.detail), true)
    document.addEventListener('update-load-table', async (event) => this.onUpdate(event.detail), true)
    document.addEventListener('configure-load-for-editor', async (event) => this.onUpdate(event.detail), true)
  }

  onUpdate(beam) {
    beamLength = beam.totalLength()
    distLoads = []
    pointLoads = []

    document.getElementById('load-dialog-error').classList.add('d-none')

    document.getElementById("dist-load-ending-at-input").value = showFeetInches(beamLength)

    document.getElementById("point-load-location-input").value = showFeetInches(beamLength * 0.5)

    for(let i = 0; i < beam.distLoads.length; i++) {
      const l = beam.distLoads[i]
      distLoads.push(new DistLoad(l.x1, l.x2, l.D, l.D2, l.isLinear))
    }

    for(let i = 0; i < beam.pointLoads.length; i++) {
      const l = beam.pointLoads[i]
      pointLoads.push(new PointLoad(l.x, l.D, l.isMoment))
    }
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="load-editor-dialog" tabindex="-1" role="dialog"
      aria-labelledby="load-editor-dialog-label" aria-hidden="true">
      <div class="modal-dialog shadow">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id='load-editor-dialog-title'>Edit Loads</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- distributed loads -->
            <span id="distributed-load-dialog-table" class="panel-body">
              <table class='table'>
                <tr>
                  <td>Start Location</td>
                  <td><input class='text-center' style='width:100px;' id='dist-load-starting-at-input' type='text' name='dist-load-starting-at-input'
                      value='0' /></td>
                  <td><button type="button" class="btn btn-sm btn-success" id='dist-load-left-button'>Left
                      End</button></td>
                </tr>
                <tr>
                  <td>End Location</td>
                  <td><input class='text-center' style='width:100px;' id='dist-load-ending-at-input' type='text' name='dist-load-ending-at-input'
                      value='0' /></td>
                  <td><button type="button" class="btn btn-sm btn-success" id='dist-load-right-button'>Right
                      End</button></td>
                </tr>
                <tr>
                  <td>Magnitude (k/ft)</td>
                  <td><input class='text-center' style='width:100px;' id='dist-load-start-magnitude' type='text' name='dist-load-start-magnitude' value='1.00' /> kip/ft
                  </td>
                  <td></td>
                </tr>
                <tr id="dist-load-end-magnitude-row">
                  <td>End Magnitude (k/ft)</td>
                  <td><input class='text-center' style='width:100px;' id='dist-load-end-magnitude' type='text' name='dist-load-start-magnitude' value='10.00' /> kip/ft
                  </td>
                  <td></td>
                </tr>
              </table>
            </span>

            <!-- point loads -->
            <span id="point-load-dialog-table" class="panel-body">
              <table class='table'>
                <tr>
                  <td>Location</td>
                  <td><input class='text-center' style='width:100px;' id='point-load-location-input' type='text' name='point-load-location-input'value='0' /></td>
                  <td><button type="button" class="btn btn-sm btn-success" id='point-load-left-button'>Left End</button></td>
                  <td><button type="button" class="btn btn-sm btn-success" id='point-load-right-button'>Right End</button></td>
                </tr>
                <tr id='point-load-magnitude-row'>
                  <td>Magnitude (kips)</td>
                  <td><input class='text-center' style='width:100px;' id='point-load-magnitude' type='text' name='point-load-magnitude' value='1.00' /> kips
                  </td>
                  <td></td>
                </tr>
                <tr id='moment-load-magnitude-row'>
                  <td>Magnitude (kip-ft)</td>
                  <td><input class='text-center' style='width:100px;' id='moment-load-magnitude' type='text' name='moment-load-magnitude' value='1.00' /> kip-ft
                  </td>
                  <td></td>
                </tr>
              </table>
            </span>

            <div id='load-dialog-error' class="alert alert-danger d-none" role="alert">
              Validation box
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger me-auto" id="delete-load-button">Delete Load</button>
            <button type="button" class="btn btn-success" id="save-load-button">Save</button>
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
      `

    document.getElementById('dist-load-left-button').onclick = () => onLeftEndClick()
    document.getElementById('dist-load-right-button').onclick = () => onRightEndClick()
    document.getElementById('point-load-left-button').onclick = () => onLeftEndClick()
    document.getElementById('point-load-right-button').onclick = () => onRightEndClick()
  }
}

customElements.define('load-editor-dialog-component', LoadEditorDialogComponent);

function onLeftEndClick() {
  document.getElementById("dist-load-starting-at-input").value = showFeetInches(0)
  document.getElementById("point-load-location-input").value = showFeetInches(0)
}

function onRightEndClick() {
  document.getElementById("dist-load-ending-at-input").value = showFeetInches(beamLength)
  document.getElementById("point-load-location-input").value = showFeetInches(beamLength)
}

function onDistLoadDelete(index) {
  document.dispatchEvent(new CustomEvent('remove-dist-load', {detail: index}))
  Modal.getOrCreateInstance(document.getElementById('load-editor-dialog')).hide()
}

function onPointLoadDelete(index) {
  document.dispatchEvent(new CustomEvent('remove-point-load', {detail: index}))
  Modal.getOrCreateInstance(document.getElementById('load-editor-dialog')).hide()
}

export function openUniformLoadDialog(loadIndex) {
  const title = loadIndex !== undefined ? 'Edit Uniform Load' : 'New Uniform Load'
  if(loadIndex !== undefined) {
    document.getElementById('delete-load-button').classList.remove('d-none')
    document.getElementById('delete-load-button').onclick = () => onDistLoadDelete(loadIndex)
    // configure 
    const load = distLoads[loadIndex] //new DistLoad(0, 144, 1, 1, false)
    document.getElementById('dist-load-starting-at-input').value = showFeetInches(load.x1)
    document.getElementById('dist-load-ending-at-input').value = showFeetInches(load.x2)
    document.getElementById('dist-load-start-magnitude').value = showBigLinearForce(load.D)
    document.getElementById('dist-load-end-magnitude').value = showBigLinearForce(load.D2)
  } else {
    document.getElementById('delete-load-button').classList.add('d-none')
  }
  document.getElementById('load-editor-dialog-title').innerHTML = title
  document.getElementById('distributed-load-dialog-table').classList.remove('d-none')
  document.getElementById('point-load-dialog-table').classList.add('d-none')
  document.getElementById('dist-load-end-magnitude-row').classList.add('d-none')

  document.getElementById('save-load-button').onclick = () => onSaveUnifromLoadClick(loadIndex)
  
  Modal.getOrCreateInstance(document.getElementById('load-editor-dialog')).show()
}

export function openLinearLoadDialog(loadIndex) {
  const title = loadIndex !== undefined ? 'Edit Linear Load' : 'New Linear Load'
  if(loadIndex !== undefined) {
    document.getElementById('delete-load-button').classList.remove('d-none')
    document.getElementById('delete-load-button').onclick = () => onDistLoadDelete(loadIndex)
    // configure 
    //const load = new DistLoad(0, 144, 1, 10, true)
    const load = distLoads[loadIndex]
    document.getElementById('dist-load-starting-at-input').value = showFeetInches(load.x1)
    document.getElementById('dist-load-ending-at-input').value = showFeetInches(load.x2)
    document.getElementById('dist-load-start-magnitude').value = showBigLinearForce(load.D)
    document.getElementById('dist-load-end-magnitude').value = showBigLinearForce(load.D2)
  } else {
    document.getElementById('delete-load-button').classList.add('d-none')
  }
  document.getElementById('load-editor-dialog-title').innerHTML = title
  document.getElementById('distributed-load-dialog-table').classList.remove('d-none')
  document.getElementById('point-load-dialog-table').classList.add('d-none')
  document.getElementById('dist-load-end-magnitude-row').classList.remove('d-none')

  document.getElementById('save-load-button').onclick = () => onSaveLinearLoadClick(loadIndex)

  Modal.getOrCreateInstance(document.getElementById('load-editor-dialog')).show()
}

export function openPointLoadDialog(loadIndex) {
  const title = loadIndex !== undefined ? 'Edit Point Load' : 'New Point Load'
  if(loadIndex !== undefined) {
    document. getElementById('delete-load-button').classList.remove('d-none')
    document.getElementById('delete-load-button').onclick = () => onPointLoadDelete(loadIndex)
    // configure 
    //const load = new PointLoad(72, 100, false)
    const load = pointLoads[loadIndex]
    document.getElementById('point-load-location-input').value = showFeetInches(load.x)
    document.getElementById('point-load-magnitude').value = showKips(load.D)
  } else {
    document.getElementById('delete-load-button').classList.add('d-none')
  }
  document.getElementById('load-editor-dialog-title').innerHTML = title
  document.getElementById('distributed-load-dialog-table').classList.add('d-none')
  document.getElementById('point-load-dialog-table').classList.remove('d-none')
  document.getElementById('point-load-magnitude-row').classList.remove('d-none')
  document.getElementById('moment-load-magnitude-row').classList.add('d-none')

  document.getElementById('save-load-button').onclick = () => onSavePointLoadClick(loadIndex)
  
  Modal.getOrCreateInstance(document.getElementById('load-editor-dialog')).show()
}

export function openMomentLoadDialog(loadIndex) {
  const title = loadIndex !== undefined ? 'Edit Moment Load' : 'New Moment Load'
  if(loadIndex !== undefined) {
    document.getElementById('delete-load-button').classList.remove('d-none')
    document.getElementById('delete-load-button').onclick = () => onPointLoadDelete(loadIndex)
    // configure
    //const load = new PointLoad(72, 100, true)
    const load = pointLoads[loadIndex]
    document.getElementById('point-load-location-input').value = showFeetInches(load.x)
    document.getElementById('moment-load-magnitude').value = showKipFt(load.D)
  } else {
    document.getElementById('delete-load-button').classList.add('d-none')
  }
  document.getElementById('load-editor-dialog-title').innerHTML = title
  document.getElementById('distributed-load-dialog-table').classList.add('d-none')
  document.getElementById('point-load-dialog-table').classList.remove('d-none')
  document.getElementById('point-load-magnitude-row').classList.add('d-none')
  document.getElementById('moment-load-magnitude-row').classList.remove('d-none')
  
  document.getElementById('save-load-button').onclick = () => onSaveMomentLoadClick(loadIndex)
  
  Modal.getOrCreateInstance(document.getElementById('load-editor-dialog')).show()
}

const positionValidation = (value) => value >= 0 && value <= beamLength
const forceValidation = (value) => true

function onSaveUnifromLoadClick(index) {
  try {    
    const x1 = validateAndGet('dist-load-starting-at-input', wsParseLength, positionValidation, 'Position must be on the beam.')
    const x2 = validateAndGet('dist-load-ending-at-input', wsParseLength, positionValidation, 'Position must be on the beam.')
    if((x2 - x1) === 0) {
      throw("Load length must be greater than zero.")
    }
    if(x1 >= x2) {
      throw("Starting position can't be larger than the ending position.")
    }
    const D = validateAndGet('dist-load-start-magnitude', parseFloat, forceValidation, 'Invalid distributed load.')
    const detail = {x1: x1, x2: x2, D: D * 1000 / 12, D2: D * 1000 / 12, isLinear: false, loadIndex: index}
    if(index !== undefined) {
      // update uniform load
      document.dispatchEvent(new CustomEvent('update-dist-load', {detail: detail}))
    } else {
      // create new load
      document.dispatchEvent(new CustomEvent('add-dist-load', {detail: detail}))
    }
    Modal.getOrCreateInstance(document.getElementById('load-editor-dialog')).hide()
  } catch(e) {
    console.log(e)
    document.getElementById('load-dialog-error').classList.remove('d-none')
    document.getElementById('load-dialog-error').innerHTML = e
  }
}

function onSaveLinearLoadClick(index) {
  try {
    const x1 = validateAndGet('dist-load-starting-at-input', wsParseLength, positionValidation, 'Position must be on the beam.')
    const x2 = validateAndGet('dist-load-ending-at-input', wsParseLength, positionValidation, 'Position must be on the beam.')
    if((x2 - x1) === 0) {
      throw("Load length must be greater than zero.")
    }
    if(x1 >= x2) {
      throw("Starting position can't be larger than the ending position.")
    }
    const D = validateAndGet('dist-load-start-magnitude', wsParseForcePerLength, forceValidation, 'Invalid distributed load.')
    const D2 = validateAndGet('dist-load-end-magnitude', wsParseForcePerLength, forceValidation, 'Invalid distributed load.')  
    const detail = {x1: x1, x2: x2, D: D * 1000 / 12, D2: D2 * 1000 / 12, isLinear: true, loadIndex: index}
    if(index !== undefined) {
      // update uniform load
      document.dispatchEvent(new CustomEvent('update-dist-load', {detail: detail}))
    } else {
      // create new load
      document.dispatchEvent(new CustomEvent('add-dist-load', {detail: detail}))
    }
    Modal.getOrCreateInstance(document.getElementById('load-editor-dialog')).hide()
  } catch(e) {
    console.log(e)
    document.getElementById('load-dialog-error').classList.remove('d-none')
    document.getElementById('load-dialog-error').innerHTML = e
  }
}

function onSavePointLoadClick(index) {
  try {
    const x = validateAndGet('point-load-location-input', wsParseLength, positionValidation, 'Position must be on the beam.')
    const D = validateAndGet('point-load-magnitude', wsParseForce, forceValidation, 'Invalid point load.')
    const detail = {x: x, D: D * 1000, isMoment: false, loadIndex: index}
    if(index !== undefined) {
      // update uniform load
      document.dispatchEvent(new CustomEvent('update-point-load', {detail: detail}))
    } else {
      // create new load
      document.dispatchEvent(new CustomEvent('add-point-load', {detail: detail}))
    }
    Modal.getOrCreateInstance(document.getElementById('load-editor-dialog')).hide()
  } catch(e) {
    console.log(e)
    document.getElementById('load-dialog-error').classList.remove('d-none')
    document.getElementById('load-dialog-error').innerHTML = e
  }
}

function onSaveMomentLoadClick(index) {
  try {
    const x = validateAndGet('point-load-location-input', wsParseLength, positionValidation, 'Position must be on the beam.')
    const D = validateAndGet('moment-load-magnitude', wsParseMoment, forceValidation, 'Invalid moment load.')
    const detail = {x: x, D: D * 1000 * 12, isMoment: true, loadIndex: index}
    if(index !== undefined) {
      // update uniform load
      document.dispatchEvent(new CustomEvent('update-point-load', {detail: detail}))
    } else {
      // create new load
      document.dispatchEvent(new CustomEvent('add-point-load', {detail: detail}))
    }
    Modal.getOrCreateInstance(document.getElementById('load-editor-dialog')).hide()
  } catch(e) {
    console.log(e)
    document.getElementById('load-dialog-error').classList.remove('d-none')
    document.getElementById('load-dialog-error').innerHTML = e
  }
}